module.exports = __webpack_public_path__ + "img/checkmark-square.e37f5183.svg";